import React, { useEffect, useState } from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import FormLabel from "@material-ui/core/FormLabel";
import TextField from '@material-ui/core/TextField';

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "../../styles.js"

const AddressComponent = props => {
  const { classes } = props;

  const [line1, setLine1] = useState("");
  const [line1Error, setLine1Error] = useState(false);
  const [line2, setLine2] = useState("");
  const [line2Error, setLine2Error] = useState(false);
  const [town, setTown] = useState("");
  const [townError, setTownError] = useState(false);
  const [province, setProvince] = useState("");
  const [provinceError, setProvinceError] = useState(false);
  const [postalCode, setPostalCode] = useState("");
  const [postalCodeError, setPCError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  
    useEffect(() => {
        props.handleChange("txtField", getFullAddress(), props.iteration, isError())
    }, [line1, line2, town, province, postalCode])

  let handleChange = (field, value) => {
    switch (field) {
        case "line1":
            setLine1(value)
            setLine1Error(getFieldError(value, field))
            break;
        case "line2":
            setLine2(value)
            setLine2Error(getFieldError(value, field))
            break;
        case "town":
            setTown(value)
            setTownError(getFieldError(value, field))
            break;
        case "province":
            setProvince(value)
            setProvinceError(getFieldError(value, field))
            break;
        case "postalcode":
            setPostalCode(value)
            setPCError(getFieldError(value, field))
            break;
        default:
            return true
    } 
}

    let isError = () => {
        if(line1Error || line2Error 
            || townError || provinceError
            || postalCodeError || checkForBlankFields())
            return true
        else return false
    }

    let checkForBlankFields = () => {
        let fieldsArray = [line1, town, province, postalCode]
        let isThereBlankField = false

        fieldsArray.forEach((item) => {
            if(checkIfBlank(item)){
                isThereBlankField = true
            }
        });
        return isThereBlankField
    }

    let getFieldError = (value, field) =>{
        if(checkIfBlank(value) && field !== "line2"){
           return true 
        } else {
            return testValue(value)
        }
    }

    let testValue = (value) => {
        let hasError = !props.apiRegex.address.regex.test(value)
        if(hasError)
            setErrorMessage(props.apiRegex.address.errorMessage)
        else
            setErrorMessage(null)
        return hasError
    }

    let checkIfBlank = (value) => {
        if(value == "" || value == null) {
            setErrorMessage("Field cannot be blank")
            return true
        } else {
                setErrorMessage(null)
                return false
            }
    }

    let getFullAddress = () => {
        let fullAddress = ""
        if (line1 !== "") 
            fullAddress = fullAddress + line1
        if(line2 !== "")
            fullAddress = fullAddress + ", " + line2
        if(town !== "") 
            fullAddress = fullAddress + ", " + town 
        if(province !== "")
            fullAddress = fullAddress + ", " + province
        if(postalCode !== "") 
            fullAddress = fullAddress + ", " + postalCode
        return fullAddress
    }

  return (
    <div>
        <GridContainer
            className={classes.containerLine}
            alignItems="center"
        >
            <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                    Address line 1
                </FormLabel>
            </GridItem>
            <GridItem xs={6}>
                <TextField
                    required
                    id={"txtId" + props.iteration}
                    error={line1Error}
                    label="Required"
                    onChange={(event) => {
                            handleChange("line1", event.target.value)
                        }
                    }
                    className={classes.txtField}/>
                    {line1Error ? errorMessage : null}
            </GridItem>
        </GridContainer>
        <GridContainer
            className={classes.containerLine}
            alignItems="center"
        >
            <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                    Address line 2
                </FormLabel>
            </GridItem>
            <GridItem xs={6}>
                <TextField
                    error={line2Error}
                    label="Optional"
                    onChange={(event) => {
                        handleChange("line2", event.target.value)
                    }
                }
                    className={classes.txtField}/>
                    {line2Error ? errorMessage : null}
            </GridItem>
        </GridContainer>
        <GridContainer
            className={classes.containerLine}
            alignItems="center"
        >
            <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                    Town
                </FormLabel>
            </GridItem>
            <GridItem xs={6}>
                <TextField
                    required
                    error={townError}
                    label="Required"
                    onChange={(event) => {
                        handleChange("town", event.target.value)
                    }
                }
                    className={classes.txtField}/>
                    {townError ? errorMessage : null}
            </GridItem>
        </GridContainer>
        <GridContainer
            className={classes.containerLine}
            alignItems="center"
        >
            <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                    Province
                </FormLabel>
            </GridItem>
            <GridItem xs={6}>
                <TextField
                    required
                    error={provinceError}
                    label="Required"
                    onChange={(event) => {
                            handleChange("province",event.target.value,)
                        }
                    }
                    className={classes.txtField}/>
                    {provinceError ? errorMessage : null}
            </GridItem>
        </GridContainer>
        <GridContainer
            className={classes.containerLine}
            alignItems="center"
        >
            <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                    Postal code
                </FormLabel>
            </GridItem>
            <GridItem xs={6}>
                <TextField
                    required
                    error={postalCodeError}
                    label="Required"
                    onChange={(event) => {
                            handleChange("postalcode",event.target.value)
                        }
                    }
                    className={classes.txtField}/>
                    {postalCodeError ? errorMessage : null}
            </GridItem>
        </GridContainer>
    </div>
  );
};

export default withStyles(styles)(AddressComponent);
